import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, pipe } from "rxjs";
import { map } from "rxjs/operators";
import {
    Bodytype,
    Characteristic,
    EurocodeRecord,
    Glassposition,
    Glasstint,
    Glasstype,
    Model,
} from "src/app/argic/domain/eurocode";
import { LoginService } from "src/app/login/login.service";
import { AcType } from "src/app/models/ac-type";
import { Manufacturer } from "src/app/models/manufacturer";
import { environment } from "src/environments/environment";
import { EurocodeChangeRequest } from "../domain/eurocodechangerequest";
import { EurocodeHistoric } from "../domain/eurocodehistoric";

@Injectable({
    providedIn: "root",
})
export class FilterdataService {
    constructor(private http: HttpClient, private loginService: LoginService) {}

    getHistorics(eurocode: string): Observable<EurocodeHistoric[]> {
        return this.http
            .get<EurocodeHistoric[]>(
                environment.apiWizardUrl +
                    "EurocodeHistoric/QueryEurocode?eurocode=" +
                    eurocode,
                {
                    withCredentials: true,
                }
            )
            .pipe(
                map((x) => {
                    let data = x;
                    data.forEach((x) => {
                        x.ParsedChangeDate = new Date(
                            parseInt(
                                x.ChangeDate.replace("/Date(", "").replace(
                                    ")/",
                                    ""
                                ),
                                10
                            )
                        );
                        let langid = this.loginService.userprofile.languageId;
                        let langfield;
                        switch (langid) {
                            case 1:
                                langfield = "Descr_EN";
                                break;
                            case 2:
                                langfield = "Descr_DE";
                                break;
                            case 3:
                                langfield = "Descr_FR";
                                break;
                            case 4:
                                langfield = "Descr_IT";
                                break;
                            case 5:
                                langfield = "Descr_ES";
                                break;
                            case 6:
                                langfield = "Descr_NL";
                                break;
                        }
                        x.Description = x[langfield];
                        if (x.Description == null || x.Description.length == 0)
                            x.Description = x.Descr_EN;
                    });
                    return data;
                })
            );
    }

    getChangeRequests(eurocode: string): Observable<EurocodeChangeRequest[]> {
        return this.http
            .get<EurocodeChangeRequest[]>(
                environment.apiWizardUrl +
                    "EurocodeHistoric/ChangeRequests?eurocode=" +
                    eurocode,
                {
                    withCredentials: true,
                }
            )
            .pipe(
                map((x) => {
                    let data = x;
                    data.forEach((x) => {
                        if (
                            x.HistoricDate != null &&
                            x.HistoricDate.toLowerCase() != "null"
                        )
                            x.ParsedHistoricDate = new Date(
                                parseInt(
                                    x.HistoricDate.replace(
                                        "/Date(",
                                        ""
                                    ).replace(")/", ""),
                                    10
                                )
                            );
                    });
                    return data;
                })
            );
    }

    getFiles(eurocode: string): Observable<EurocodeHistoric[]> {
        return this.http.get<EurocodeHistoric[]>(
            environment.apiWizardUrl + "Upload/Files/" + eurocode,
            {
                withCredentials: true,
            }
        );
    }

    //Calls to REST API (migrate to MVC later)
    getAcTypes(): Observable<AcType[]> {
        return this.http.get<AcType[]>(environment.apiUrl + "api/Actypes");
    }

    getOne(eurocode: string): Observable<EurocodeRecord> {
        return this.http
            .get<EurocodeRecord>(
                environment.apiUrl + "api/EurocodeRecords/" + eurocode
            )
            .pipe(
                map((data) => {
                    data.oes =
                        data.oeS1 ?? "" + data.oeS2 ?? "" + data.oeS3 ?? "";
                    data.oem =
                        data.oeM1 ?? "" + data.oeM2 ?? "" + data.oeM3 ?? "";
                    data.sameas =
                        data.sameaS1 ??
                        "" + data.sameaS2 ??
                        "" + data.sameaS3 ??
                        "";
                    data.fulldes_EN = data.des_EN ?? "";
                    if (data.char_EN)
                        data.fulldes_EN += "\n" + (data.char_EN ?? "");
                    if (data.modif_EN)
                        data.fulldes_EN += "\n" + (data.modif_EN ?? "");
                    if (data.descr_EN)
                        data.fulldes_EN += "\n" + (data.descr_EN ?? "");

                    data.fulldes_EN = data.fulldes_EN.toUpperCase();

                    return data;
                })
            );
    }

    getAll(searchdata: any): Observable<EurocodeRecord[]> {
        return this.http
            .get<EurocodeRecord[]>(
                environment.apiUrl +
                    "api/EurocodeRecords/q/" +
                    JSON.stringify(searchdata)
            )
            .pipe(
                map((l) => {
                    l.forEach((data) => {
                        data.oes =
                            (data.oeS1 ?? "") +
                            (data.oeS2 ?? "") +
                            (data.oeS3 ?? "");
                        data.oem =
                            (data.oeM1 ?? "") +
                            (data.oeM2 ?? "") +
                            (data.oeM3 ?? "");
                        data.sameas =
                            (data.sameaS1 ?? "") +
                            (data.sameaS2 ?? "") +
                            (data.sameaS3 ?? "");

                        data.fulldes_EN = data.des_EN ?? "";
                        if (data.char_EN ?? false)
                            data.fulldes_EN += "\n" + (data.char_EN ?? "");
                        if (data.modif_EN ?? false)
                            data.fulldes_EN += "\n" + (data.modif_EN ?? "");
                        if (data.descr_EN ?? false)
                            data.fulldes_EN += "\n" + (data.descr_EN ?? "");

                        data.fulldes_EN = data.fulldes_EN.toUpperCase();
                    });
                    return l;
                })
            );
    }

    getManufacturer(id: number): Observable<Manufacturer> {
        return this.http.get<Manufacturer>(
            environment.apiUrl + "api/Manufacturers/" + id
        );
    }
    getManufacturers(): Observable<Manufacturer[]> {
        return this.http.get<Manufacturer[]>(
            environment.apiUrl + "api/Manufacturers/"
        );
    }
    getModels(): Observable<Model[]> {
        return this.http.get<Model[]>(environment.apiUrl + "api/Models/");
    }
    getModelsQuery(searchdata: any): Observable<Model[]> {
        console.log(searchdata);
        return this.http.get<Model[]>(
            environment.apiUrl + "api/Models/q/" + JSON.stringify(searchdata)
        );
    }
    getCharacteristics(): Observable<Characteristic[]> {
        return this.http
            .get<Characteristic[]>(environment.apiUrl + "api/Characteristics/")
            .pipe(
                map((data) =>
                    data.sort((a, b) => {
                        if (a.charID < b.charID) {
                            return -1;
                        }
                        if (a.charID > b.charID) {
                            return 1;
                        }
                        return 0;
                    })
                )
            );
    }
    getGlasstypes(): Observable<Glasstype[]> {
        return this.http.get<Glasstype[]>(
            environment.apiUrl + "api/Glasstypes/"
        );
    }
    getGlasstints(): Observable<Glasstint[]> {
        return this.http.get<Glasstint[]>(
            environment.apiUrl + "api/GlassTint/"
        );
    }
    getGlasstoptints(): Observable<Glasstint[]> {
        return this.http.get<Glasstint[]>(
            environment.apiUrl + "api/GlassTint/"
        );
    }
    getBodytypes(): Observable<Bodytype[]> {
        return this.http.get<Bodytype[]>(environment.apiUrl + "api/BodyType/");
    }
    getGlasspositions(): Observable<Glassposition[]> {
        return this.http.get<Glassposition[]>(
            environment.apiUrl + "api/GlassPosition/"
        );
    }
}
